import { render, staticRenderFns } from "./OidcPopupCallback.vue?vue&type=template&id=115963a0&"
import script from "./OidcPopupCallback.vue?vue&type=script&lang=js&"
export * from "./OidcPopupCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports